export default "__VITE_ASSET__BMO7lZW8__"